import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'common-door-icon',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './door-icon.component.html',
  styleUrls: ['./door-icon.component.scss'],
})
export class DoorIconComponent {
  @Input() color!: string;
}
